import { mapGetters } from 'vuex';

export default {
    computed: {
        isFullModification() {
            return typeof this.booking !== 'undefined' && typeof this.quote !== 'undefined' && this.booking.quote_id !== null && this.booking.quote_id !== this.quote.id;
        },

        isModificationPresent() {
            return (
                (typeof this.modification !== 'undefined' && typeof this.modification.status !== 'undefined') ||
                (window.location.href.includes('/edit') && typeof this.booking !== 'undefined' && this.booking.reference !== null)
            );
        },

        ...mapGetters({
            booking: 'getBooking',
            modification: 'getModification',
            quote: 'getQuote',
        }),
    },
};
